import { render, staticRenderFns } from "./MachineBackupsTable.vue?vue&type=template&id=2a032183&scoped=true&"
import script from "./MachineBackupsTable.vue?vue&type=script&lang=js&"
export * from "./MachineBackupsTable.vue?vue&type=script&lang=js&"
import style0 from "./MachineBackupsTable.vue?vue&type=style&index=0&id=2a032183&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a032183",
  null
  
)

export default component.exports